/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lessons_Create_StudentInputs */

const en_lessons_create_student = /** @type {(inputs: Lessons_Create_StudentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create student`)
};

const he_lessons_create_student = /** @type {(inputs: Lessons_Create_StudentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`יצירת תלמיד`)
};

/**
* | output |
* | --- |
* | "Create student" |
*
* @param {Lessons_Create_StudentInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const lessons_create_student = /** @type {((inputs?: Lessons_Create_StudentInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lessons_Create_StudentInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_lessons_create_student(inputs)
	return he_lessons_create_student(inputs)
});